var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { FormGroup } from "../../Forms";
import { Captcha } from "../../ReactReduxForms";
import { Translate } from "../../I18N";



const CaptchaComponent = ({ remote, refresh }) => /*#__PURE__*/
_jsx(FormGroup, { model: ".captcha" }, "captcha", /*#__PURE__*/
_jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx("label", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Captcha"), /*#__PURE__*/
_jsx("span", { className: "required" }, void 0, "*")
)
), /*#__PURE__*/
_jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
_jsx(Captcha, { remote: remote, refresh: refresh, model: ".captcha" })
)
)
);


export const FormCaptcha = /*#__PURE__*/React.memo(CaptchaComponent);